import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Nav/nav';
import { css } from '@patternfly/react-styles';
import { getUniqueId } from '../../helpers/util';
export var NavGroup = function NavGroup(_a) {
  var title = _a.title,
      _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$id = _a.id,
      id = _a$id === void 0 ? getUniqueId() : _a$id,
      props = __rest(_a, ["title", "children", "className", "id"]);

  return React.createElement("section", Object.assign({
    className: css(styles.navSection, className),
    "aria-labelledby": id
  }, props), React.createElement("h2", {
    className: css(styles.navSectionTitle),
    id: id
  }, title), React.createElement("ul", null, children));
};